export default __webpack_public_path__ + "static/media/icon_document-search.39a7d237.svg";